
          const templateString = `<div class="account-message">
  <img src="" alt="" id="account-logo" />
  <h4 id="game-title"></h4>
  <p>
    Save your game stats, view leaderboards, early game updates, see your streaks,
    and join our community.
  </p>
  <a
    href="{{ dashboardBaseUrl }}/register?redirect_uri={{ returnTo }}"
    id="free-account-link"
  >
    Get Your Free Account
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icons Navigation">
        <path
          id="Vector 108"
          d="M6 12.5H18M18 12.5L12.1463 6.5M18 12.5L12.1463 18.5"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  </a>
</div>
<nav class="sidebar-menu mobile-only">
  <a
    class="menu-item"
    href="{{ dashboardBaseUrl }}/dashboard/{{ gameKey }}?return_to={{ returnTo }}"
    id="stats-link"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_12805_2551)">
        <path d="M2 12H6V23H2V12Z" fill="#FCFAFA" />
        <path d="M8 1H17V5H13V23H8V1Z" fill="var(--heygg-primary-color)" />
        <path d="M15 7H22V23H15V7Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_12805_2551">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
    Stats
  </a>
  <a
    class="menu-item"
    href="{{ dashboardBaseUrl }}/profile?return_to={{ returnTo }}"
    id="settings-link"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_12887_4417)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.4333 3.55049L5.89718 1.61806L5.40157 6.52364L0.684585 7.95905L3.45817 12.0355L0.767417 16.1671L5.51241 17.507L6.10691 22.4016L10.6031 20.378L14.2047 23.7454L16.3482 19.3051L21.2716 19.5696L20.0596 14.7903L24.0011 11.8282L20.0006 8.9462L21.116 4.14347L16.1989 4.50724L13.9662 0.111174L10.4333 3.55049ZM14.2815 7.90682L7.95918 9.66946L9.72182 15.9918L16.0442 14.2292L14.2815 7.90682Z"
          fill="var(--heygg-primary-color)"
        />
      </g>
      <defs>
        <clipPath id="clip0_12887_4417">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
    Settings
  </a>
  <a class="menu-item" href="{{ howToPlayURL }}" id="how-to-play-link">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="var(--heygg-primary-color)"
      />
      <path
        d="M8 8.37679C8.00011 7.76792 8.19517 7.1704 8.56453 6.64746C8.93389 6.12452 9.46382 5.69561 10.0982 5.40613C10.7327 5.11665 11.448 4.97736 12.1685 5.003C12.8889 5.02864 13.5878 5.21826 14.1911 5.55179C14.7945 5.88532 15.2798 6.35036 15.5957 6.89769C15.9116 7.44502 16.0464 8.05428 15.9859 8.661C15.9253 9.26772 15.6716 9.84933 15.2516 10.3443C14.8316 10.8392 14.2609 11.2291 13.6 11.4727C13.1245 11.6479 12.7198 11.9365 12.4356 12.303C12.1514 12.6695 12 13.0981 12 13.5362V14"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="12" cy="18" r="1" fill="black" />
    </svg>
    How to Play
  </a>
</nav>
`;

          export default {
            render(data = {}) {
              if (!data) data = {};

              let result = templateString;

              // First, process conditional if tags
              // Match pattern: {{:if attribute}}...{{:/if}}
              result = this._processIfTags(result, data);

              // Then replace variables
              result = result.replace(/\{\{\s*([^}]+)\s*\}\}/g, (match, key) => {
                const trimmedKey = key.trim();
                // Check if the property exists in data
                return (trimmedKey in data) ? data[trimmedKey] : match;
              });

              return result;
            },

            // Helper method to process if tags
            _processIfTags(template, data) {
              // Regular expression to match {{:if attribute}}...{{:/if}}
              const ifTagRegex = /\{\{:if\s+([^}]+)\}\}([\s\S]*?)\{\{:\/if\}\}/g;

              return template.replace(ifTagRegex, (match, attribute, content) => {
                let conditionMet = false;

                try {
                  // Parse the attribute path
                  const attributeParts = attribute.trim().split('.');
                  let value = data;

                  // Navigate through nested properties
                  for (const part of attributeParts) {
                    if (value === undefined || value === null) {
                      value = undefined;
                      break;
                    }
                    value = value[part];
                  }

                  // Check truthiness of the value
                  conditionMet = Boolean(value);
                } catch (error) {
                  console.warn('Error evaluating condition:', attribute, error);
                  conditionMet = false;
                }

                // Return the content if condition is met, otherwise empty string
                return conditionMet ? content : '';
              });
            },

            template: templateString
          };
        